import api from '../api'
import { useMutation } from '@tanstack/react-query'
import { ApiRouteEnum } from '../../enums/ApiRouteEnum'

export const usePatchFlexiGroup = (
  successCallBack: (data: any) => void,
  errorCallBack: (data: any) => void,
  id: string,
) => {
  const flexiGroupDetailsEndpoint: string = ApiRouteEnum.FLEXI_EDIT.replace('<id>', id)
  return useMutation(
    (flexiGroupData: any) => api.patch(flexiGroupDetailsEndpoint, flexiGroupData),
    {
      mutationKey: [flexiGroupDetailsEndpoint],
      onSuccess: (data) => {
        successCallBack(data.data)
      },
      onError: (error) => errorCallBack(error),
    },
  )
}
